import { render, staticRenderFns } from "./btn-2.vue?vue&type=template&id=6d53e4c0&scoped=true&"
import script from "./btn-2.vue?vue&type=script&lang=js&"
export * from "./btn-2.vue?vue&type=script&lang=js&"
import style0 from "./btn-2.vue?vue&type=style&index=0&id=6d53e4c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d53e4c0",
  null
  
)

export default component.exports